import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { LocalizedText } from 'src/components/intl'
import { getColor } from 'src/styles'
import BigCalendarEvent from './BigCalendarEvent'
import styles from './BigCalendar.scss'

const localizer = momentLocalizer(moment)

// translated calendar messages
const messages = {
  date: <LocalizedText id="WEB_DATE" />,
  time: <LocalizedText id="WEB_TIME" />,
  allDay: <LocalizedText id="WEB_ALL_DAY" />,
  week: <LocalizedText id="WEB_WEEK" />,
  day: <LocalizedText id="WEB_DAY" />,
  month: <LocalizedText id="WEB_MONTH" />,
  today: <LocalizedText id="WEB_TODAY" />,
}

// custom event component
const components = {
  event: BigCalendarEvent,
}

// custom event classes
const eventPropGetter = event => ({
  className: classnames(styles.event, { [styles.disabled]: event.disabled }),
  style: { backgroundColor: getColor(event.color) },
})

const BigCalendar = ({ events, ...props }) => (
  <Calendar
    {...props}
    showMultiDayTimes
    toolbar={false}
    localizer={localizer}
    events={events}
    messages={messages}
    components={components}
    eventPropGetter={eventPropGetter}
  />
)

BigCalendar.defaultProps = {
  events: [],
}

BigCalendar.propTypes = {
  events: PropTypes.array,
}

export default BigCalendar
